/* eslint-disable no-loop-func */
import { useEffect, useContext } from "react";
import styleAddNewTaxDeclaration from "./AddNewTaxDeclaration.module.css";
import MainContent from "../../../layouts/maincontent/MainContent";
import { useState } from "react";

import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import AppealRequestData from "../../../components/taxAppeal/appealRequestData/AppealRequestdata";
import { getTaxAppealStoreAllLookups } from "../../../adapters/apis/lookups/lookups";
import TaxAppealContext from "../../../contexts/TaxAppealProvider";

function AddNewTaxAppeal() {
  const navigate = useNavigate();
  const taxAppealContext = useContext(TaxAppealContext);
  const { appealRequest, user, setUser } = taxAppealContext;

  const [isLoading, setIsLoading] = useState(false);
  const [appealReasonTypes, setAppealReasonTypes] = useState([]);
  const [appealTypes, setAppealTypes] = useState([]);
  const [nationalitiesTypes, setNationalitiesTypes] = useState([]);
  const [govs, setGovs] = useState([]);
  const [unitAddressTypes, setUnitAddressTypes] = useState([]);
  const [unitOwnerTypes, setUnitOwnerTypes] = useState([]);
  const [unitTypes, setUnitTypes] = useState([]);
  const [facilityTypes, setFacilityTypes] = useState([]);

  const [appealTaxPeriods, setAppealTaxPeriods] = useState([]);
  const [submitterTypes, setSubmitterTypes] = useState([]);
  const [doYouWantExtraAttachments, setDoYouWantExtraAttachments] = useState(
    []
  );

  const initializeData = async () => {
    setIsLoading(true);
    try {
      let url = "api/category/tax-appeal/all-lookups";

      if (appealRequest?.disableAfterPaymentDifferentPeriod) {
        url = `api/category/tax-appeal/all-lookups?id=${
          appealRequest?.id || appealRequest?.linked_id
        }`;
      }

      if (appealRequest?.editMode) {
        url = `api/category/tax-appeal/all-lookups?id=${
          appealRequest?.id || appealRequest?.linked_id
        }&editMode=true`;
      }
      
      const [lookupRes] = await Promise.all([getTaxAppealStoreAllLookups(url)]);

      setAppealReasonTypes(lookupRes.data.data.appeal_reason_types);
      setAppealTypes(lookupRes.data.data.appeal_types);
      setAppealTaxPeriods(lookupRes.data.data.appealed_tax_period_types);
      setGovs(lookupRes.data.data.governorates);
      setNationalitiesTypes(lookupRes.data.data.nationalities_types);
      setSubmitterTypes(lookupRes.data.data.submitter_types);
      setUnitAddressTypes(lookupRes.data.data.unit_address_types);
      setUnitOwnerTypes(lookupRes.data.data.unit_owner_types);
      setUnitTypes(lookupRes.data.data.unit_types);
      setFacilityTypes(lookupRes.data.data.facility_types);
      setDoYouWantExtraAttachments(
        lookupRes.data.data
          .appeal_do_you_want_extra_attachments_for_request_types
      );

      setUser((prev) => ({
        ...prev,
        first_name: lookupRes.data.data.user.profile.first_name,
        father_name: lookupRes.data.data.user.profile.second_name,
        grandfather_name: lookupRes.data.data.user.profile.third_name,
        family_name: lookupRes.data.data.user.profile.fourth_name,
        email: lookupRes.data.data.user.email,
        phone_number: lookupRes.data.data.user.profile.mobile,
        nationality: {
          id: lookupRes.data.data.user.profile.nationality.id,
          key: lookupRes.data.data.user.profile.nationality.code,
          value: lookupRes.data.data.user.profile.nationality.name,
        },
        national_id: lookupRes.data.data.user.profile.national_id,
        passport_number: lookupRes.data.data.user.profile.passport_num,
        building_number: lookupRes.data.data.user.profile.real_estate_num,
        governorate_id: lookupRes.data.data.user.profile.governorate_id,
        district_id: lookupRes.data.data.user.profile.district_id,
        village_id: lookupRes.data.data.user.profile.village_id,
        street_id: lookupRes.data.data.user.profile.street_id ?? -1,
        street_other: lookupRes.data.data.user.profile.street_other,
        national_id_file:
          lookupRes.data.data.user.profile.national_id_file?.[0] || null,
        passport_number_file:
          lookupRes.data.data.user.profile.passport_num_file?.[0] || null,
        profile: lookupRes.data.data.user.profile,
      }));

      setIsLoading(false);
    } catch (error) {
      console.error("Initialization error:", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsLoading(true);
    initializeData();
  }, [navigate]);

  return (
    <MainContent>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <section
          className={`${styleAddNewTaxDeclaration["section-content"]} section-content`}
        >
          <div
            className={`${styleAddNewTaxDeclaration.container} container pt-5`}
          >
            <div
              className={`${styleAddNewTaxDeclaration["card-box"]} card-box`}
            >
              <div
                className={`${styleAddNewTaxDeclaration["box-content"]} box-content`}
              >
                <AppealRequestData
                  user={user}
                  appealReasonTypes={appealReasonTypes}
                  appealTypes={appealTypes}
                  appealTaxPeriods={appealTaxPeriods}
                  govs={govs}
                  nationalitiesTypes={nationalitiesTypes}
                  submitterTypes={submitterTypes}
                  unitAddressTypes={unitAddressTypes}
                  unitOwnerTypes={unitOwnerTypes}
                  unitTypes={unitTypes}
                  facilityTypes={facilityTypes}
                  doYouWantExtraAttachments={doYouWantExtraAttachments}
                />
              </div>
            </div>
          </div>
        </section>
      )}
    </MainContent>
  );
}

export default AddNewTaxAppeal;
